import { action, decorate, observable } from 'mobx';
// This is used to share the same ActivityNotificationsStore between the
// notification dropdown in the header and the activity-notifications app.
// We want them to update in sync when the user makes a change, e.g. marks a notification as read.
const globalState = {
  store: null
};
decorate(globalState, {
  store: observable.ref
});
export const setGlobalActivityNotificationsStore = action(store => {
  globalState.store = store;
});
export const getGlobalActivityNotificationsStore = () => globalState.store;
//# sourceMappingURL=global-activity-notifications.js.map